// Generated by Melange

import * as Caml_obj from "melange.js/caml_obj.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Lui_elements from "lui/lui_elements.js";
import * as Mapre_web__Web_comments_model from "./web_comments_model.js";
import * as Mapre_web__Web_model from "./web_model.js";
import * as Signal from "ocaml-signal/signal.js";
import * as Stdlib__Option from "melange/option.js";
import * as Stdlib__String from "melange/string.js";

function allowed(m) {
  if (Mapre_web__Web_model.can_create(m)) {
    return !Mapre_web__Web_model.locked(m);
  } else {
    return false;
  }
}

function view(model, send) {
  const source = Signal.map((function (m) {
    return m.comments;
  }), model);
  const partial_arg = "Comments";
  const partial_arg$1 = 2;
  const partial_arg$2 = "No member comments yet.";
  const partial_arg$3 = "muted";
  const partial_arg$4 = function (param, param$1) {
    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg$5 = Signal.map((function (p) {
    if (Caml_obj.caml_equal(p.items, /* [] */ 0)) {
      return p.message === "";
    } else {
      return false;
    }
  }), source);
  const partial_arg$6 = Signal.map((function (p) {
    return p.items;
  }), source);
  const partial_arg$7 = {
    TAG: /* Comments */ 47,
    _0: /* Refresh */ 3
  };
  const partial_arg$8 = (function (param) {
    return Lui_elements.press(send, partial_arg$7, param);
  });
  const partial_arg$9 = "ghost";
  const partial_arg$10 = "Refresh comments";
  const partial_arg$11 = {
    TAG: /* Comments */ 47,
    _0: /* More */ 4
  };
  const partial_arg$12 = (function (param) {
    return Lui_elements.press(send, partial_arg$11, param);
  });
  const partial_arg$13 = "outline";
  const partial_arg$14 = "Load more comments";
  const partial_arg$15 = function (param, param$1) {
    return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$14, undefined, partial_arg$13, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$12, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg$16 = Signal.map((function (p) {
    return p.next_cursor !== undefined;
  }), source);
  const partial_arg$17 = {
    TAG: /* Comments */ 47,
    _0: /* Retry */ 2
  };
  const partial_arg$18 = (function (param) {
    return Lui_elements.press(send, partial_arg$17, param);
  });
  const partial_arg$19 = "outline";
  const partial_arg$20 = "Retry same comment";
  const partial_arg$21 = function (param, param$1) {
    return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$20, undefined, partial_arg$19, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$18, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg$22 = Signal.map((function (p) {
    return Stdlib__Option.fold(false, (function (a) {
      return a.uncertain;
    }), p.attempt);
  }), source);
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.scoped((function (__lui_context___004_) {
      const partial_arg = {
        TAG: /* Comments */ 47,
        _0: /* Submit */ 1
      };
      const partial_arg$1 = (function (param) {
        return Lui_elements.press(send, partial_arg, param);
      });
      const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___004_.ui_scope, Signal.map((function (m) {
        return !(allowed(m) && Mapre_web__Web_comments_model.can_submit(m.comments));
      }), model)));
      const partial_arg$3 = "primary";
      const partial_arg$4 = "Post comment";
      return function (param, param$1) {
        return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      };
    }), param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$10, undefined, partial_arg$9, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$8, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.if_(partial_arg$16, partial_arg$15, param, param$1);
      }),
      tl: {
        hd: (function (param, param$1) {
          return Lui_elements.if_(partial_arg$22, partial_arg$21, param, param$1);
        }),
        tl: /* [] */ 0
      }
    }
  };
  const partial_arg$23 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$24 = "wrap";
  const partial_arg$25 = 8;
  const partial_arg$26 = "Your role can read comments but cannot post them.";
  const partial_arg$27 = "muted";
  const partial_arg$28 = function (param, param$1) {
    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$27, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$26, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg$29 = Signal.map((function (m) {
    return !allowed(m);
  }), model);
  const partial_arg$30 = Signal.map((function (p) {
    return p.message !== "";
  }), source);
  const partial_arg$31 = "Posting comment...";
  const partial_arg$32 = "muted";
  const partial_arg$33 = function (param, param$1) {
    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$32, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$31, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg$34 = Signal.map((function (p) {
    return Stdlib__Option.fold(false, (function (a) {
      return !a.uncertain;
    }), p.attempt);
  }), source);
  const partial_arg_0$1 = function (param, param$1) {
    return Lui_elements.heading(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1$1 = {
    hd: (function (param, param$1) {
      return Lui_elements.if_(partial_arg$5, partial_arg$4, param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.keyed(partial_arg$6, (function (c) {
          return c.id;
        }), Stdlib__String.compare, (function (c) {
          const partial_arg_0 = function (param, param$1) {
            return Lui_elements.scoped((function (__lui_context___001_) {
              const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___001_.ui_scope, Signal.map((function (c) {
                return c.actor_id;
              }), c)));
              const partial_arg$1 = "muted";
              return function (param, param$1) {
                return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
              };
            }), param, param$1);
          };
          const partial_arg_1 = {
            hd: (function (param, param$1) {
              return Lui_elements.scoped((function (__lui_context___002_) {
                const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___002_.ui_scope, Signal.map((function (c) {
                  return c.body;
                }), c)));
                return function (param, param$1) {
                  return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                };
              }), param, param$1);
            }),
            tl: /* [] */ 0
          };
          const partial_arg = {
            hd: partial_arg_0,
            tl: partial_arg_1
          };
          const partial_arg$1 = 0;
          const partial_arg$2 = 2;
          return function (param, param$1) {
            return Lui_elements.column(undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, param, param$1);
          };
        }), param, param$1);
      }),
      tl: {
        hd: (function (param, param$1) {
          return Lui_elements.scoped((function (__lui_context___003_) {
            const partial_arg = (function (param) {
              return Lui_elements.on_input(send, (function (value) {
                return {
                  TAG: /* Comments */ 47,
                  _0: {
                    TAG: /* Draft */ 6,
                    _0: value
                  }
                };
              }), param);
            });
            const partial_arg$1 = Caml_option.some(Signal.own_signal(__lui_context___003_.ui_scope, Signal.map((function (m) {
              return !allowed(m);
            }), model)));
            const partial_arg$2 = "Comment";
            const partial_arg$3 = "Share a note with workspace members...";
            const partial_arg$4 = Caml_option.some(Signal.own_signal(__lui_context___003_.ui_scope, Signal.map((function (p) {
              return p.draft;
            }), source)));
            return function (param, param$1) {
              return Lui_elements.textarea(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, partial_arg$3, undefined, partial_arg$2, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, /* [] */ 0, param, param$1);
            };
          }), param, param$1);
        }),
        tl: {
          hd: (function (param, param$1) {
            return Lui_elements.row(undefined, partial_arg$25, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$24, undefined, partial_arg$23, param, param$1);
          }),
          tl: {
            hd: (function (param, param$1) {
              return Lui_elements.if_(partial_arg$29, partial_arg$28, param, param$1);
            }),
            tl: {
              hd: (function (param, param$1) {
                return Lui_elements.if_(partial_arg$30, (function (param, param$1) {
                  return Lui_elements.scoped((function (__lui_context___005_) {
                    const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___005_.ui_scope, Signal.map((function (p) {
                      return p.message;
                    }), source)));
                    const partial_arg$1 = "notice";
                    return function (param, param$1) {
                      return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                    };
                  }), param, param$1);
                }), param, param$1);
              }),
              tl: {
                hd: (function (param, param$1) {
                  return Lui_elements.if_(partial_arg$34, partial_arg$33, param, param$1);
                }),
                tl: /* [] */ 0
              }
            }
          }
        }
      }
    }
  };
  const partial_arg$35 = {
    hd: partial_arg_0$1,
    tl: partial_arg_1$1
  };
  const partial_arg$36 = "form-card";
  const partial_arg$37 = 0;
  const partial_arg$38 = 16;
  const partial_arg$39 = 8;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$39, undefined, undefined, undefined, undefined, undefined, partial_arg$38, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$37, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$36, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$35, param, param$1);
  };
}

export {
  view,
}
/* Lui_elements Not a pure module */
